import str_plural from '@src/helpers/str_plural';
import {IClientRouteNamesResolver} from '@src/@interfaces/services/NameResolvers/IClientRouteNamesResolver';
import {snake_case} from '@src/helpers/string-registres';

export default class ClientRouteNamesResolver implements IClientRouteNamesResolver {
    static INDEX_ROUTE_NAME = 'index';
    static IMPORT_ROUTE_NAME = 'import';
    static SHOW_ROUTE_NAME = 'show';
    static CREATE_ROUTE_NAME = 'store';
    static UPDATE_ROUTE_NAME = 'show';

    getIndexRouteName(modelName: string): string {
        return this.resolve(modelName, 'INDEX_ROUTE_NAME');
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getImportRouteName(modelName: string): string {
        return `abstract@${ClientRouteNamesResolver.IMPORT_ROUTE_NAME}`;
    }

    getShowRouteName(modelName: string): string {
        return this.resolve(modelName, 'SHOW_ROUTE_NAME');
    }

    getCreateRouteName(modelName: string): string {
        return this.resolve(modelName, 'CREATE_ROUTE_NAME');
    }

    getUpdateRouteName(modelName: string): string {
        return this.resolve(modelName, 'UPDATE_ROUTE_NAME');
    }

    getRouteName(modelName: string, actionName: string): string {
        return this.resolve(modelName, actionName);
    }

    protected resolve(modelName: string, constantName: keyof typeof ClientRouteNamesResolver | string): string {
        const modelPreparedName = snake_case(str_plural(modelName), '-');
        const action = constantName in ClientRouteNamesResolver ?
            ClientRouteNamesResolver[constantName as keyof typeof ClientRouteNamesResolver] :
            constantName;

        return modelPreparedName + '@' + action;
    }
}
